import { BackButton, Button, SecondaryButton } from "../../components";
import { SuccessIcon } from "../../assets/svg";
import { navigateTo } from "../../helper";
import { connect, useDispatch } from "react-redux";
import { cleanUpClaimInfo } from "../../store/ace2-claim/actions";
import { RootState } from "../../store/root-reducer";
import { useTranslation } from "react-i18next";

function SubmitClaim({ claim, claimNumber = "" }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClick = () => {
    dispatch(cleanUpClaimInfo());
    navigateTo("/");
  };

  const CLAIM_STATUS_URL = `${process.env.REACT_APP_ACE2_CLAIM_STATUS_URL}/${
    claim?.status_code || ""
  }`;

  return (
    <div className="px-2 mt-3">
      <BackButton onClick={handleClick} text={t("Home")} />
      <div className="flex  flex-col items-center gap-8 mt-4 px-2">
        <SuccessIcon size={98} />
        <span className="text-2xl font-semibold text-center ">
          {t("Thank you for submitting your claim.")}
        </span>
        <div className="bg-[#F8F8F8] border-[#EDEDED] border p-3 flex flex-col items-center rounded-lg gap-1">
          <span className="text-[#505050] text-lg">{t("Claim Number")}</span>
          <span className="font-semibold text-4xl text-[#22222C]">
            {claimNumber}
          </span>
        </div>
        <div className="bg-red-50 text-red-700 font-semibold border-red-500 border p-3 rounded-lg gap-1 text-center text-sm -my-5">
          You will receive a notification with a status update within the next
          2–3 business days. In the meantime, you may the claim status page list
          below for the latest updates
        </div>
        <span className="text-base text-[#696969] break-all text-center">
          {CLAIM_STATUS_URL}
        </span>
        <div className="space-y-3 w-full">
          <a href={CLAIM_STATUS_URL} target="_blank" rel="noreferrer">
            <Button className="">{t("Claim status page")}</Button>
          </a>
          <SecondaryButton onClick={handleClick}>
            {t("Back to Home")}
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state: RootState) => ({
  claim: state.ace2Claim.data,
  claimNumber: state?.ace2Claim?.data?.["Name"] || "",
});

export default connect(mapStateToProps)(SubmitClaim);
